import React, { useEffect, useState } from "react";
import "./orderVerify.style.scss";
import { Card } from "antd";
import Loading from "../../../../loading/loading.index";
import { post, responseValidator, SERVER } from "../../../../api";
import axios from "axios";

export default function OrderVerify() {
    const [loading, setLoading] = useState(true);
    const URL = window.location;
    const trackingCode = URL.pathname.split("/")[4];
    const payment = URL.toString().includes('payment_status=OK')||URL.toString().includes('&status=1&state_code=') ;
    const requiredVerify=URL.toString().includes('state=SUCCESSFUL&payment')  ? false : true;
    const [apiVerify, setApiVerify] = useState(false);
    const [data, setDate] = useState(undefined)
const isBot=URL.toString().includes('platform=Bot') ? true :false  ;
    const isApp=URL.toString().includes('platform=App') ? true :false  ;
    const isWaiting=URL.toString().includes('waiting=true')? true :false  ;
    function checkVerify() {
        const headers = {
            'Content-Type': 'application/json'
        }
        axios.post(`${SERVER}/Order/Verify/IRT`, { trackingCode }, {
            headers: headers
        }).then(res => {
            setLoading(false);
            if (responseValidator(res.status)) {
                setDate(res.data)
                console.log(data);
                setApiVerify(true);
            }
            else setApiVerify(false);
        }).catch(err => {
            setLoading(false);
            setApiVerify(false);
        })
    }

    useEffect(() => {

        if (payment && requiredVerify) checkVerify();
        else if(!requiredVerify){
            setLoading(false);
            setApiVerify(true);

        }
        else {

            setLoading(false);
            setApiVerify(false);

        }
    }, []);

    if (loading) return <Loading />;
    return (
        <React.Fragment>
            {( apiVerify) ? (
                <div className="order-verify-page success">
                    <Card className="content">
                        <i className="fas fa-check-circle" />
                        {
                            isWaiting?
                                <><p>درخواست شما با موفقیت ثبت شد و نتیجه آن از طریق پیامک اطلاع رسانی خواهد شد.
                                </p>
                                    <p>
                                        برای مشاهده جزئیات تراکنش بر روی دکمه زیر کلیک‌نمایید.</p>
                                </>
                                :
                            <p>عملیات با موفقیت انجام شد.</p>
                        }

                        <span>کد پیگیری شما : {trackingCode}</span>
                        {data &&
                            data.voucherActivation ? <span>فعال ساز ووچر : {data.voucherActivation}</span> : ""}

                        {data && data.voucherCode ? <span>کد ووچر : {data.voucherCode}</span> : ""}

                        {
                            isBot
                            ?
                                <p
                                    onClick={() =>
                                        window.location.replace(
                                            "https://t.me/Temx_bot"
                                        )
                                    }
                                    className="order-details-button"
                                >
                                 بازگشت به ربات
                                </p>
                                :
                                isApp ?
                                    <p
                                        onClick={() =>
                                            window.location.replace(
                                                "temx://app.com/transactionhistory?status=true"
                                            )
                                        }
                                        className="order-details-button"
                                    >
                                        بازگشت به برنامه
                                    </p>
                                    :

                                <p
                            onClick={() =>
                                window.location.replace(
                                    "/userpanel/orderhistory"
                                )
                            }
                            className="order-details-button"
                        >
                            مشاهده جزئیات سفارش
                        </p>

                        }
                    </Card>
                </div>
            ) : (
                <div className="order-verify-page error">
                    <Card className="content">
                        <i className="fas fa-times-circle" />
                        <p>عملیات با خطا مواجه شد.</p>
                        <span>کد پیگیری شما : {trackingCode}</span>
                        {
                            isBot
                                ?
                                <p
                                    onClick={() =>
                                        window.location.replace(
                                            "https://t.me/Temx_bot"
                                        )
                                    }
                                    className="order-details-button"
                                >
                                    بازگشت به ربات
                                </p>
                                :
                                isApp ?
                                    <p
                                        onClick={() =>
                                            window.location.replace(
                                                "temx://app.com/transactionhistory?status=false"
                                            )
                                        }
                                        className="order-details-button"
                                    >
                                        بازگشت به برنامه
                                    </p>
                                    :

                                <p
                                    onClick={() =>
                                        window.location.replace(
                                            "/userpanel/orderhistory"
                                        )
                                    }
                                    className="order-details-button"
                                >
                                    مشاهده جزئیات سفارش
                                </p>

                        }
                    </Card>
                </div>
            )}
        </React.Fragment>
    );
}
